import { useCallback } from 'react';
import styled from 'styled-components';
import { LocalStorageKey, localStorageRemove } from '../../data/client_local_storage.ts';
import { useLocalStorage } from '../../data/use_local_storage.tsx';
import { alert } from '../../util/confirm.tsx';
import '../settings_page.css';

export const LoggingPage = () => {
  const [logMessages] = useLocalStorage(LocalStorageKey.Logging);

  const clearLogMessages = useCallback(() => {
    localStorageRemove(LocalStorageKey.Logging);
  }, []);

  const copyLogMessages = useCallback(async () => {
    const messagesAsText = logMessages.join('\n');
    await navigator.clipboard.writeText(messagesAsText);
    await alert({ confirmation: <span>Log copied to clipboard</span> });
  }, [logMessages]);

  return (
    <div className="settingsContent">
      <ScrollContainer>
        <Buttons>
          <ClearAllButton onClick={clearLogMessages}>Clear Log</ClearAllButton>
          <CopyLogButton onClick={copyLogMessages}>Copy Log</CopyLogButton>
        </Buttons>
        {[...logMessages.entries()].map(([index, message]) => {
          // TODO(hewitt): Honestly should not be using the index here
          // Makes insertion very expensive because we update the values of all DOM entries
          // in the list rather than inserting a new DOM entry
          return <Message key={index}>{message}</Message>;
        })}
      </ScrollContainer>
    </div>
  );
};

const Buttons = styled.div`
  display: flex;
`;

const ScrollContainer = styled.code`
  position: absolute;
  width: 100vw;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  justify-items: start;
`;

const Message = styled.div`
  text-align: left;
`;

const LogButton = styled.button`
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 1.2em;
  width: fit-content;
  border-radius: 15px;
  padding: 2px 12px;
  margin: 20px;
  border: none;
  color: var(--color-background);
  cursor: pointer;
`;

const ClearAllButton = styled(LogButton)`
  background-color: var(--color-dangerous-button);
`;

const CopyLogButton = styled(LogButton)`
  background-color: var(--color-friendly-button);
`;
